export const media = {
  heroBanner:
    'https://cdn.magicpatterns.com/uploads/6uuDK5uQvJX8bmYyQ8DmLi/576227F8-F8A4-4CF6-B534-BEED445C8BA8.png',
  detailSheet:
    'https://cdn.magicpatterns.com/uploads/pzDD4GfN3mgvcypUF4nrpx/9E3F6D27-ECA1-491C-A19D-28C856C7FD7E.png',
  lensSheet:
    'https://cdn.magicpatterns.com/uploads/nkw1BAZWLPjUfNNrJ25BRd/39670657-8A76-439E-9079-591CEA18FDC7.png',
  tradesSheet:
    'https://cdn.magicpatterns.com/uploads/8EQbCvptTyMGvWtQMVi1N9/6565379D-D103-4C24-AA34-60AF3A94D7DC.png',
  versusSheet:
    'https://cdn.magicpatterns.com/uploads/mPQJRpVmK3SeLw1fPpkPo7/C702DD5E-9D73-4242-9837-9BC5A6705F69.png',
  packsSheet:
    'https://cdn.magicpatterns.com/uploads/tUmGMdH9uwnaz14zcQJMuC/0C6A047A-1804-44B2-AF80-3727768F36DF.png',
  struggle: 'https://cdn.magicpatterns.com/patterns/generated-images/764a1124-49cc-46dd-a58f-1314aef79981.jpg',
}

export interface SequenceFrame {
  src: string
  alt: string
  caption: string
}

export const heroSequence: SequenceFrame[] = [
  {
    src: media.heroBanner,
    alt: 'GritVue X1 illuminated work glasses shown with all three lenses',
    caption: 'GritVue X1™. Light where you look.',
  },
  {
    src: media.lensSheet,
    alt: 'The GritVue X1 clear, amber and smoke lenses shown with workers in each condition',
    caption: 'One frame. Three lenses. Any job.',
  },
  {
    src: media.detailSheet,
    alt: 'GritVue X1 detail view of the light module, frame, lenses and charging port',
    caption: 'Dual light sources. USB-C rechargeable.',
  },
  {
    src: media.versusSheet,
    alt: 'A traditional strap headlamp compared against the GritVue X1',
    caption: 'Your headlamp just evolved.',
  },
  {
    src: media.tradesSheet,
    alt: 'Mechanics, construction, HVAC, plumbing, electrical and trucking workers wearing the X1',
    caption: 'Built for the ones who keep America working.',
  },
]

export const heroChips: string[] = [
  'Wave-on motion sensor. Never touch a button',
  '800 lumens · 14-hour runtime',
  'Only 1.4 oz, lighter than safety glasses',
  'Clear lens',
  'Amber lens',
  'Smoke lens',
  'Built-in illumination',
  'USB-C rechargeable',
  'Lifetime free replacement',
]

export interface Review {
  name: string
  trade: string
  bought: string
  quote: string
  avatar: string
}

export const reviewSummary = {
  rating: '4.9',
  reviewCount: '18,412',
  sold: '50,000+',
  fiveStarShare: '96%',
}

export const ratingBreakdown: { stars: number; percent: number }[] = [
  { stars: 5, percent: 96 },
  { stars: 4, percent: 3 },
  { stars: 3, percent: 1 },
  { stars: 2, percent: 0 },
  { stars: 1, percent: 0 },
]

export const reviews: Review[] = [
  {
    name: 'Mike R.',
    trade: 'Diesel mechanic · Texas',
    bought: 'Bought the 3-pack',
    quote:
      'Nineteen years of holding a flashlight in my teeth. First night with the X1 I did a fuel filter swap in the dark without asking anyone to hold a light. Then I ordered two more for my guys.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/bc5295c2-a272-4a62-8270-d8007db27b68.jpg',
  },
  {
    name: 'Derek H.',
    trade: 'Site foreman · Ohio',
    bought: 'Bought the crew pack',
    quote:
      'Bought six for the crew. Nobody fights over the work light anymore. One got run over by a skid steer, they replaced it free. That sold me harder than the product did.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/0d63d5c4-9ea8-4df4-8e27-f62ced2dfe3c.jpg',
  },
  {
    name: 'Travis M.',
    trade: 'HVAC tech · Arizona',
    bought: 'Bought the 3-pack',
    quote:
      'Attics, crawlspaces, dark closets all day. Amber lens in the dust, clear the rest of the time. My headlamp has been sitting in the van untouched since June.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/06ae3fed-c93e-4505-a899-1651b9595043.jpg',
  },
  {
    name: 'Ray K.',
    trade: 'Long-haul driver · Tennessee',
    bought: 'Bought the 3-pack',
    quote:
      'Chained up on the shoulder at 2am in the rain. Both hands working, light right where I was looking. Worth every dollar just for that one night.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/047d6322-e818-4aa6-a27f-10aa50cb097c.jpg',
  },
  {
    name: 'Shane P.',
    trade: 'Electrician · Pennsylvania',
    bought: 'Bought 1, came back for 3',
    quote:
      'Bought one to test it. Two weeks later I bought the 3-pack. One in the van, one in the shop, one at the house. Reading panels in a dark basement is a different job now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/6c1fb60e-874e-493d-b4c2-d68cf7bbf4c0.jpg',
  },
  {
    name: 'Marcus A.',
    trade: 'Master plumber · Illinois',
    bought: 'Bought the crew pack',
    quote:
      'Under sinks and in crawlspaces you are always fighting for light. Now I just look at the fitting and it is lit. Six in the shop, one per truck.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/c546e933-dcdc-4e02-bde7-69061e8cd7e4.jpg',
  },
  {
    name: 'Bill T.',
    trade: 'Roofer · Georgia',
    bought: 'Bought the 3-pack',
    quote:
      'Smoke lens at noon, clear when we button up at dusk. Thirty years on roofs and this is the first piece of new gear that actually changed my day.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/2275cd22-ddad-4d3a-869c-738c89f640f3.jpg',
  },
  {
    name: 'Kevin L.',
    trade: 'CNC machinist · Michigan',
    bought: 'Bought the 3-pack',
    quote:
      'Setting tools inside a machine enclosure used to mean a magnet light and a lot of cussing. Light follows my eyes now. Ordered a set for my brother.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/fde294a4-efd5-4b85-b9a8-e7bb2f0a5db6.jpg',
  },
  {
    name: 'Jess C.',
    trade: 'Welder / fabricator · Colorado',
    bought: 'Bought 1, came back for 3',
    quote:
      'Fit-up work in a dark corner of the shop is where this shines. Light on the joint, both hands on the clamp. Bought two more the same week.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/e9720eca-ce47-46b9-81c4-3d7667513eba.jpg',
  },
  {
    name: 'Hector V.',
    trade: 'Auto body tech · California',
    bought: 'Bought the 3-pack',
    quote:
      'Checking panel gaps and sanding lines, the side light shows every wave. Amber lens under the booth lights is the move. One lives in my box now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/cfc1d75f-1c5b-4b8b-ba2a-303d798acdb6.jpg',
  },
  {
    name: 'Mike D.',
    trade: 'Fleet mechanic · Missouri',
    bought: 'Bought the crew pack',
    quote:
      'Six trucks, six techs, six X1. Shop light bill went down and the dumb questions about "who has the drop light" went away completely.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/050a907d-25b4-497d-b4ac-b26f6635f4c1.jpg',
  },
  {
    name: 'Andre W.',
    trade: 'General contractor · New York',
    bought: 'Bought the 3-pack',
    quote:
      'Punch lists after dark used to end the day early. Not anymore. And the lifetime replacement means I do not baby it. I just use it.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/77f61b0b-0a2c-43d6-afd8-f07a0cee22e9.jpg',
  },
  {
    name: 'Luis M.',
    trade: 'HVAC service · Florida',
    bought: 'Bought the 3-pack',
    quote:
      'Four calls a day in attics that feel like an oven. Hands free, light on the wiring, in and out faster. My apprentice stole mine so I ordered three.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/0906c340-5965-476a-aa46-d24445fbac3e.jpg',
  },
  {
    name: 'Katie B.',
    trade: 'Electrician · Washington',
    bought: 'Bought the 3-pack',
    quote:
      'No strap means no headache at the end of a ten hour day, and my hair stays out of it. Panels I used to shoot with a phone light I just read now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/090e3d0d-7bd9-4fce-abbe-9468e7df733d.jpg',
  },
  {
    name: 'Jamal S.',
    trade: 'Electrical apprentice · Illinois',
    bought: 'Bought 1, came back for 3',
    quote:
      'First tool I bought with my own money that the journeymen kept borrowing. So I got the 3-pack and stopped lending mine out.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/168baff4-0756-4969-a9de-75f4b0ad66be.jpg',
  },
  {
    name: 'Ramon G.',
    trade: 'Concrete foreman · Nevada',
    bought: 'Bought the crew pack',
    quote:
      'Early pours start in the dark. Six of these on the crew and we are laying line at 4am like it is noon.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/9a66aacd-84fb-41a5-930d-564431e1a283.jpg',
  },
  {
    name: 'Dale F.',
    trade: 'Welder · Wisconsin',
    bought: 'Bought the 3-pack',
    quote:
      'Fit-up, grinding, layout. Light is on the work, not the ceiling. Dropped one on a steel table and it kept going.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/75697599-ffa6-4238-9697-e0543ba5fa5f.jpg',
  },
  {
    name: 'Tom B.',
    trade: 'Power lineman · Oklahoma',
    bought: 'Bought the crew pack',
    quote:
      'Storm restoration at 3am in the bucket. Hands on the hot stick, light exactly where I am looking. Whole crew runs them now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/49a26e93-eb42-4ee5-8512-aed091fed581.jpg',
  },
  {
    name: 'Amit P.',
    trade: 'Facilities maintenance · New Jersey',
    bought: 'Bought the 3-pack',
    quote:
      'Boiler rooms, ceiling tiles, electrical closets. One in the cart, one in the office, one at home. Best forty bucks in my toolbag.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/7ca118fa-f067-42c5-8e1b-dcbed51a0d94.jpg',
  },
  {
    name: 'Dave W.',
    trade: 'HVAC service · Kentucky',
    bought: 'Bought the 3-pack',
    quote:
      'Keep one clipped to the visor in the van. Pull into a call, put it on, walk in ready. Simple as that.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/7c8ab81b-ce5f-439a-b4b9-39d30b13ba89.jpg',
  },
  {
    name: 'Terrance J.',
    trade: 'Diesel mechanic · Alabama',
    bought: 'Bought the crew pack',
    quote:
      'Brake jobs under a trailer are all feel and no light. Not anymore. Bought six so nobody in the bay is without one.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/f68b47a3-9546-4979-84e4-4fe7511bc7cf.jpg',
  },
  {
    name: 'Curtis B.',
    trade: 'Plumber · Indiana',
    bought: 'Bought the 3-pack',
    quote:
      'Crawlspaces are the worst part of this job. First time I went under with both hands free I actually laughed.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/0aa6798d-a6ad-46d4-aebf-cb704ca244c1.jpg',
  },
  {
    name: 'Mariela R.',
    trade: 'Project engineer · Texas',
    bought: 'Bought the crew pack',
    quote:
      'Walking punch lists at dusk with a tablet in one hand. I stopped carrying a flashlight entirely. Ordered a set for the field team.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/395ce8f4-9626-4818-b3cc-574cd1502227.jpg',
  },
  {
    name: 'Walt H.',
    trade: 'Farmer · Iowa',
    bought: 'Bought the 3-pack',
    quote:
      'Fixing a combine at 10pm during harvest is not optional. This thing paid for itself the first night.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/a5cc5147-554e-4328-a97b-6f9fdd15e34b.jpg',
  },
  {
    name: 'Cody M.',
    trade: 'Auto detailer · Utah',
    bought: 'Bought the 3-pack',
    quote:
      'Side light shows swirls my shop lights hide. Caught two panels I would have handed back unfinished.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/6e640b19-7557-47d6-a848-bbf5a0a8f9df.jpg',
  },
  {
    name: 'Danielle O.',
    trade: 'HVAC technician · Maryland',
    bought: 'Bought 1, came back for 3',
    quote:
      'Mechanical rooms are never lit right. Bought one, my partner took it, bought three more the same week.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/075c25fa-89f2-4f79-8d27-436d4a56a278.jpg',
  },
  {
    name: 'Ernesto D.',
    trade: 'Landscaper · Arizona',
    bought: 'Bought the 3-pack',
    quote:
      'Smoke lens all summer, then the light for irrigation repairs after sundown. Two tools, one pair of glasses.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/8d9a19d9-4e03-4e52-97ce-702c1114de8b.jpg',
  },
  {
    name: 'Greg S.',
    trade: 'Low-voltage tech · Oregon',
    bought: 'Bought the 3-pack',
    quote:
      'Back of a server rack is a black hole. Punching down cable with light on the block instead of on my forehead is night and day.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/06beede9-b44f-4691-bb2e-f91dbfab5fab.jpg',
  },
  {
    name: 'Randy P.',
    trade: 'Marine mechanic · Florida',
    bought: 'Bought the crew pack',
    quote:
      'Engine compartments on boats are tight, wet and dark. Dropped mine in the bilge, they replaced it free. No argument.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/9f195893-1224-48bb-815b-131daa69568d.jpg',
  },
  {
    name: 'Austin K.',
    trade: 'Tow operator · Kansas',
    bought: 'Bought the 3-pack',
    quote:
      'Hooking up on the shoulder at 2am in the rain. Both hands on the chains and the light is on the hook. Safer, period.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/a1e0bdc9-e2e7-47f2-bada-ea8760d4f518.jpg',
  },
  {
    name: 'Renato B.',
    trade: 'Aircraft maintenance · Washington',
    bought: 'Bought the crew pack',
    quote:
      'Inspection panels and wire bundles all day. The narrow side beam is exactly what you want inside a wing.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/d9b7ae08-1532-484d-838b-eb9eef8dfa1a.jpg',
  },
  {
    name: 'Gary N.',
    trade: 'Cabinet maker · Vermont',
    bought: 'Bought the 3-pack',
    quote:
      'Fitting hinges inside a dark carcass used to mean a clamp light in the way. Now it is just me and the screw.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/e38779d1-9826-48ff-b190-ac4357ccef5f.jpg',
  },
  {
    name: 'Yvette C.',
    trade: 'Owner-operator · Arkansas',
    bought: 'Bought the 3-pack',
    quote:
      'Pre-trip in the dark at a truck stop, checking tires and lines alone. This is the first thing I grab now.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/91572965-8455-468e-ab45-7be0e2be839b.jpg',
  },
  {
    name: 'Stan L.',
    trade: 'Small engine repair · Minnesota',
    bought: 'Bought the crew pack',
    quote:
      'Forty years squinting at carburetors. My eyes are not what they were, but with this I can see the jet again.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/068199c3-af7c-43a9-9c76-c73da5fcc744.jpg',
  },
]

export const reviewStats: { value: string; label: string }[] = [
  { value: '4.9/5', label: 'Average rating' },
  { value: '50,000+', label: 'X1 shipped across America' },
  { value: '18,412', label: 'Verified reviews' },
  { value: '96%', label: 'Five-star ratings' },
]

export const benefitStrip: string[] = [
  '800 lumens',
  'Wave-on motion sensor',
  '14-hour runtime',
  'Only 1.4 oz',
  '3 lenses included',
  'Lifetime free replacement',
]

export interface GuaranteePoint {
  title: string
  body: string
  icon: 'hammer' | 'lens' | 'repeat' | 'wallet'
}

export const guaranteePoints: GuaranteePoint[] = [
  {
    title: 'Break it on the job',
    body: 'Dropped off a ladder, run over in the shop, crushed in the toolbox. We replace it free.',
    icon: 'hammer',
  },
  {
    title: 'Crack or scratch a lens',
    body: 'Clear, Amber or Smoke. Tell us which one and a new lens ships out free.',
    icon: 'lens',
  },
  {
    title: 'For life. Not 30 days',
    body: 'Included with every X1. No expiration, no registration games. One email and it is handled.',
    icon: 'repeat',
  },
  {
    title: 'You never pay for it twice',
    body: 'Buy the X1 once. Keep working with it forever. That is the whole deal.',
    icon: 'wallet',
  },
]

export const oldWay: string[] = [
  'Flashlight in your mouth',
  'Headlamp strapped around your head',
  'Constantly repositioning your light',
]

export interface ComparisonRow {
  point: string
  others: string
  gritVue: string
}

export const comparison: ComparisonRow[] = [
  {
    point: 'Where the light goes',
    others: 'Above your eyes, so the beam misses the work',
    gritVue: 'At eye level, so light follows your line of sight',
  },
  {
    point: 'Turning it on',
    others: 'Fumble for a button with greasy gloves on',
    gritVue: 'Wave your hand. The motion sensor turns it on and off',
  },
  {
    point: 'Brightness',
    others: '200 to 400 lumens, aimed wherever the strap sits',
    gritVue: '800 lumens, aimed exactly where you look',
  },
  {
    point: 'Runtime',
    others: '3 to 6 hours, then you swap batteries',
    gritVue: 'Up to 14 hours, a double shift on one charge',
  },
  {
    point: 'Weight on you',
    others: '3 to 5 oz strapped around your head',
    gritVue: '1.4 oz, lighter than your safety glasses',
  },
  {
    point: 'Eye protection',
    others: 'A second piece of gear you buy separately',
    gritVue: 'Built into the same frame',
  },
  {
    point: 'Lens options',
    others: 'One tint, or none at all',
    gritVue: '3 lenses included: Clear, Amber, Smoke',
  },
  {
    point: 'How you wear it',
    others: 'Strap around your head or hard hat',
    gritVue: 'Wears like glasses. No strap.',
  },
  {
    point: 'Hands on the job',
    others: 'One hand on the flashlight',
    gritVue: 'Both hands free, always',
  },
  {
    point: 'Charging',
    others: 'Batteries or a proprietary cable',
    gritVue: 'USB-C cable included in the box',
  },
  {
    point: 'If it breaks',
    others: 'Buy another one',
    gritVue: 'Lifetime free replacement',
  },
  {
    point: 'What it costs you',
    others: 'Headlamp + glasses + spare lenses, bought separately',
    gritVue: 'One complete system from $29.99 per X1',
  },
]

export interface ValueRow {
  item: string
  note: string
  price: string
}

export const valuePriced: ValueRow[] = [
  { item: 'GritVue X1™ Illuminated Work Glasses', note: 'Hands-free light built into the frame', price: '$79.95' },
  { item: '3 interchangeable lenses', note: 'Clear + Amber + Smoke', price: '$24.95' },
  { item: 'Premium hard protective case', note: 'Toolbag and truck ready', price: '$14.95' },
  { item: 'Microfiber storage pouch', note: 'For spare lenses', price: '$6.95' },
  { item: 'Microfiber cleaning cloth', note: 'Streak-free lens care', price: '$4.95' },
  { item: 'USB charging cable', note: 'Recharge anywhere', price: '$4.95' },
  { item: 'GritVue anti-fog lens spray', note: 'Clear through heat and sweat', price: '$9.95' },
  { item: 'Quick start guide / user manual', note: 'Up and running in minutes', price: 'Included' },
  { item: 'GritVue authenticity card', note: 'Proof of a genuine GritVue product', price: 'Included' },
  {
    item: 'Lifetime replacement warranty',
    note: 'Free with every multi-pack. Single system: 1-year coverage',
    price: '$19.95',
  },
]

export const valueTotals = {
  total: '$166.60',
  regular: '$124.95',
  payOne: '$49.95',
  /** Savings are always measured from the regular price, never from the separate value. */
  saveOne: '$75.00',
  discount: '60% off',
  payEach: '$29.99',
}

export const newWay: string[] = [
  'Light follows your line of sight',
  'Wears like glasses',
  'Three lens options',
  'Both hands stay on the job',
]

export interface Lens {
  name: string
  use: string
  body: string
  swatch: string
}

export const lenses: Lens[] = [
  {
    name: 'Clear',
    use: 'Everyday work',
    body: 'For garages, shops, indoor projects and general use.',
    swatch: 'rgba(244,244,240,0.55)',
  },
  {
    name: 'Amber',
    use: 'Low-light contrast',
    body: 'A different visual option for lower-light work environments.',
    swatch: 'rgba(243,196,0,0.85)',
  },
  {
    name: 'Smoke',
    use: 'Bright conditions',
    body: 'For outdoor and bright daytime environments.',
    swatch: 'rgba(48,52,58,0.95)',
  },
]

export const useCases: string[] = [
  'Mechanics',
  'Oil & Gas',
  'HVAC',
  'Plumbing',
  'Electrical',
  'Welding',
  'Pipefitting',
  'Construction',
  'Roofing',
  'Diesel & Fleet',
  'Refinery',
  'Trucking',
  'Farm & Ranch',
  'DIY',
  'Outdoors',
]

export const useCaseLines: string[] = [
  'Under a hood.',
  'Inside a crawlspace.',
  'Behind a dashboard.',
  'On a rig at 4am.',
  'On a roof.',
  'Inside a cabinet.',
  'At the jobsite after dark.',
]

export interface Detail {
  title: string
  body: string
  icon: 'lightbulb' | 'layers' | 'usb' | 'hands' | 'box' | 'battery' | 'glasses'
}

export const details: Detail[] = [
  { title: 'Built-in illumination', body: '800 lumens aimed right where you look.', icon: 'lightbulb' },
  { title: '3 interchangeable lenses', body: 'Clear. Amber. Smoke.', icon: 'layers' },
  { title: 'USB-C rechargeable', body: 'Full charge in 90 minutes. 14 hours of light.', icon: 'usb' },
  { title: 'Battery display', body: 'Digital readout tells you exactly what you have left.', icon: 'battery' },
  {
    title: 'Prescription-ready',
    body: 'Optional GritVue X1 RX Insert™ sits behind the lens. Sold separately.',
    icon: 'glasses',
  },
  { title: 'Hands-free design', body: 'No handheld flashlight required.', icon: 'hands' },
  {
    title: 'Wave-on motion sensor',
    body: 'Wave your hand to turn the light on and off. No button, gloves stay on.',
    icon: 'hands',
  },
  { title: 'Tool-free lens swap', body: 'Pop one lens out, snap the next in. No screws, no tools.', icon: 'layers' },
  { title: 'Compact', body: 'Keep it in your toolbox, truck, garage or work bag.', icon: 'box' },
]

export interface Offer {
  id: 'single' | 'trio' | 'crew'
  eyebrow?: string
  kicker?: string
  name: string
  units: string
  price: string
  compareAt?: string
  save?: string
  perUnit?: string
  /** The one line that should hit hardest on the card. */
  highlight?: string
  /** Combined-runtime claim, always paired with the footnote. */
  runtime?: string
  footnote?: string
  splitNote?: { title: string; body: string; each: string }
  mysteryGift?: boolean
  freeShipping: boolean
  note: string
  supporting: string[]
  includes: string[]
  cta: string
  badge?: string
  featured: boolean
  /** Product photo shown above the price. Add one per pack as photos arrive. */
  image?: string
  imageAlt?: string
  /** Shopify variant id. When set, the pack button goes straight to the Shopify cart with the chosen quantity. */
  variantId?: string
  /** Short discount chip shown beside the price, e.g. "60% off". */
  discountBadge?: string
}

/** The complete system every X1 ships as, used in cards and the value stack. */
export const completeSystem = (n: number): string[] => {
  const q = (label: string, plural = label + 's') => (n === 1 ? `1 ${label}` : `${n} ${plural}`)
  return [
    q('GritVue X1™ Illuminated Work Glasses', 'GritVue X1™ Illuminated Work Glasses'),
    n === 1 ? '3 interchangeable lenses: Clear, Amber, Smoke' : `${n * 3} interchangeable lenses: ${n} each Clear, Amber, Smoke`,
    q('premium hard protective case', 'premium hard protective cases'),
    q('microfiber storage pouch', 'microfiber storage pouches'),
    q('microfiber cleaning cloth'),
    q('USB charging cable'),
    q('GritVue anti-fog lens spray', 'GritVue anti-fog lens sprays'),
    q('quick start guide'),
    q('authenticity card'),
    // Lifetime coverage is a multi-pack benefit; the single system carries 1 year.
    n === 1 ? '1-year replacement coverage' : 'Lifetime Replacement Warranty',
  ]
}

export const SHOP_CART_URL = 'https://shop.gritvuegear.com/cart'

export const checkoutUrl = (variantId: string, qty: number) => `${SHOP_CART_URL}/${variantId}:${qty}`

export const offers: Offer[] = [
  {
    id: 'single',
    variantId: '45095500546141',
    image: 'https://cdn.magicpatterns.com/uploads/62TbYaRUMT2QUsxfNZ92St/D3D967EB-F303-4189-842F-BCB4DB15CDF8.png',
    imageAlt:
      'GritVue X1 Work-Ready Kit: illuminated X1 frame, Clear, Amber and Smoke lenses, protective hard case, anti-fog spray and retail box',
    eyebrow: 'Veterans Day Sale',
    kicker: 'Single system',
    name: '1 GritVue X1 Complete System',
    units: '1 complete system',
    price: '$49.95',
    compareAt: '$124.95',
    save: 'You save $75.00',
    discountBadge: '60% off',
    freeShipping: false,
    note: 'Shipping calculated at checkout.',
    supporting: ['Wave-on motion sensor. No button to press.'],
    includes: completeSystem(1),
    cta: 'Get the X1 — $49.95',
    featured: false,
  },
  {
    id: 'trio',
    eyebrow: 'Most popular',
    kicker: 'Buy 2, get 1 free',
    name: '3 Complete Systems',
    units: '3 GritVue X1 complete systems',
    price: '$99.90',
    compareAt: '$374.85',
    save: 'Save $274.95',
    perUnit: 'Only $33.30 per X1',
    highlight: 'Buy 2. Get 1 free.',
    runtime: 'Up to 10 hours of combined light*',
    footnote:
      '*Up to approximately 10 hours of combined runtime when using all three X1 units sequentially. Runtime varies by light mode and usage. Regular retail value based on 3 × $124.95.',
    splitNote: {
      title: 'Work with a crew?',
      body: 'Split the pack with two coworkers.',
      each: 'Only $33.30 each when split evenly.',
    },
    mysteryGift: true,
    freeShipping: true,
    note: 'Free U.S. shipping.',
    supporting: ['Every X1 is a complete system, including the free one.'],
    includes: [...completeSystem(3), 'Free mystery gift'],
    cta: 'Get 3 X1 Systems — $99.90',
    featured: true,
  },
  {
    id: 'crew',
    eyebrow: 'Best value',
    kicker: 'Buy 4, get 2 free',
    name: '6 Complete Systems',
    units: '6 GritVue X1 complete systems',
    price: '$179.95',
    compareAt: '$749.70',
    save: 'Save $569.75',
    perUnit: 'Only $29.99 per X1',
    highlight: 'Buy 4. Get 2 free.',
    footnote: 'Regular retail value based on 6 × $124.95.',
    mysteryGift: true,
    freeShipping: true,
    note: 'Free U.S. shipping.',
    supporting: ['More systems. Lower cost per X1.', 'Every unit is a complete system.'],
    includes: [...completeSystem(6), 'Free mystery gift'],
    cta: 'Get 6 X1 Systems — $179.95',
    featured: false,
  },
]

/**
 * The gear that ships with every order, shown as one visual value stack.
 * `image` is intentionally empty for the branded accessories: drop the final
 * GritVue hard case and anti-fog renders in here and the tiles pick them up
 * with no layout change. Never substitute a generic stand-in product photo.
 */
export interface GearItem {
  name: string
  tag: string
  note: string
  qty: string
  image?: string
}

export const includedGear: GearItem[] = [
  {
    name: 'GritVue X1',
    tag: 'The gear',
    note: 'Illuminated frame with the wave-on motion sensor and USB-C charging.',
    qty: 'One per unit ordered',
    image: media.detailSheet,
  },
  {
    name: 'Clear, Amber, Smoke lenses',
    tag: 'Included',
    note: 'Three tints per frame, swapped tool-free for the conditions in front of you.',
    qty: 'Three per unit ordered',
  },
  {
    name: 'Premium Hard Protective Case',
    tag: '$14.95 value',
    note: 'Keeps the frame and lenses safe in the toolbag or truck.',
    qty: 'One per system',
  },
  {
    name: 'Care system',
    tag: '$11.90 value',
    note: 'Microfiber storage pouch and microfiber cleaning cloth.',
    qty: 'One set per system',
  },
  {
    name: 'GritVue Anti-Fog Lens Spray',
    tag: '$9.95 value',
    note: 'Clear vision through heat, cold and sweat.',
    qty: 'One per system',
  },
  {
    name: 'USB charging',
    tag: '$4.95 value',
    note: 'USB charging cable in every box.',
    qty: 'One per system',
  },
  {
    name: 'Authenticity card + quick start guide',
    tag: 'Included',
    note: 'GritVue authenticity card and user manual.',
    qty: 'One per system',
  },
  {
    name: 'Lifetime Replacement Warranty',
    tag: '$19.95 value',
    note: 'Break it. We replace it. Included free with every multi-pack. Terms apply.',
    qty: 'Every system',
  },
  {
    name: 'Mystery Gift',
    tag: 'Free on multi-packs',
    note: "There's something else in the box. We're not telling you what it is. No clues. No extra charge.",
    qty: 'One per qualifying multi-pack order, while supplies last',
  },
]

export const companyPack = {
  topBadge: 'For business owners & work crews',
  secondaryBadge: 'Best bulk value',
  title: 'Business / Crew Pack',
  offer: 'Buy 20. Get 10 free.',
  units: '30 GritVue X1 complete systems',
  priceValue: 599.95,
  compareValue: 1498.5,
  saveValue: 898.55,
  price: '$599.95',
  perUnit: 'Only about $20 per X1',
  savings: 'You save $898.55',
  comparison: '30 × $49.95 Veterans Day price: $1,498.50',
  headline: 'The smarter way to outfit your entire crew.',
  subheadline: '30 complete systems for about $20 each.',
  copy: 'One crew. One order. 30 complete, work-ready systems. Built for the people who keep the job moving, priced for the owners who buy for all of them.',
  cta: 'Outfit your crew — get 30 for $599.95',
  ctaNote: 'One crew. One order. 30 complete systems.',
  includes: [
    '30 GritVue X1™ Illuminated Work Glasses',
    '90 interchangeable lenses: 30 Clear, 30 Amber, 30 Smoke',
    '30 premium hard protective cases',
    '30 microfiber storage pouches',
    '30 microfiber cleaning cloths',
    '30 USB charging cables',
    '30 GritVue anti-fog lens sprays',
    '30 quick start guides / user manuals',
    '30 GritVue authenticity cards',
    'Free U.S. shipping',
    'Lifetime Replacement Warranty for eligible systems while the warranty promotion is active',
  ],
  /** Cost per unit across every offer, so the bulk price is undeniable. */
  ladder: [
    { label: '1 X1 complete system', each: '$49.95 each' },
    { label: '3 X1 · Buy 2, get 1 free', each: '$33.30 each' },
    { label: '6 X1 · Buy 4, get 2 free', each: '$29.99 each' },
    { label: '30 X1 Business / Crew Pack', each: 'About $20 each', best: true },
  ],
  /** Stacking smaller bundles to 30 units always costs more. */
  stacking: [
    { label: '10 × Buy 2, get 1 free', total: '$999.00' },
    { label: '5 × Buy 4, get 2 free', total: '$899.75' },
    { label: 'Business / Crew Pack', total: '$599.95', best: true },
  ],
  stackingHighlights: ['Save $399.05 vs ten 3-packs', 'Save $299.80 vs five 6-packs'],
}

export const valueStack: string[] = [
  'GritVue X1™ Illuminated Work Glasses',
  'Clear, Amber and Smoke interchangeable lenses',
  'Premium hard protective case',
  'Microfiber storage pouch and cleaning cloth',
  'USB charging cable',
  'GritVue anti-fog lens spray',
  'Quick start guide and authenticity card',
  'Lifetime replacement warranty',
]

export interface BundleReason {
  title: string
  body: string
  icon: 'toolbox' | 'truck' | 'garage' | 'crew'
}

export const bundleReasons: BundleReason[] = [
  { title: 'Toolbox', body: 'Keep one with your tools.', icon: 'toolbox' },
  { title: 'Truck', body: 'Never leave home without one.', icon: 'truck' },
  { title: 'Garage', body: 'Always have one ready.', icon: 'garage' },
  { title: 'Crew / gift', body: "Give one to the guy who's always borrowing your gear.", icon: 'crew' },
]

export interface Assurance {
  title: string
  body: string
  icon: 'ship' | 'clock' | 'return' | 'infinity'
}

export const assurances: Assurance[] = [
  {
    title: 'Shipped USPS from the U.S.',
    body: 'Every order leaves one of our U.S. warehouses insured and tracked. No overseas wait, no customs surprises.',
    icon: 'ship',
  },
  {
    title: 'Delivered in 3 to 6 business days',
    body: 'Orders placed before 2pm CT ship the same business day, with USPS tracking emailed to you.',
    icon: 'clock',
  },
  {
    title: '30-day returns, no questions',
    body: "Don't like it? Send it back within 30 days for a full refund. Return shipping is on us.",
    icon: 'return',
  },
  {
    title: 'Lifetime free replacement',
    body: 'Break it, crack it, scratch a lens. We replace it free, for as long as you own it.',
    icon: 'infinity',
  },
]

export const shippingNote =
  'Shipped USPS, insured and tracked. Free U.S. shipping on every multi-pack. Single X1 orders have shipping calculated at checkout.'

export interface Spec {
  label: string
  value: string
}

/**
 * Only claims GritVue can stand behind for this production model. Add runtime,
 * charge time and weight here once they are measured — nothing is invented.
 */
export const performance: { value: string; label: string; note: string }[] = [

  {
    value: 'Wave',
    label: 'Motion sensor on/off',
    note: 'Wave your hand in front of the frame and the light turns on or off. No button, no gloves off.',
  },
  {
    value: '800',
    label: 'Lumens',
    note: 'Dual LED output aimed at your line of sight. Brighter than most work headlamps.',
  },
  {
    value: '14 hrs',
    label: 'Runtime',
    note: 'Up to 14 hours on low, 5 on high. A double shift without a charge.',
  },
  {
    value: '90 min',
    label: 'Full charge',
    note: 'USB-C from empty to full in 90 minutes. 10 minutes gets you an hour.',
  },
  {
    value: '1.4 oz',
    label: 'Weight',
    note: 'Lighter than your safety glasses. Nothing on your head, nothing on your neck.',
  },
]

export const specs: Spec[] = [
  {
    label: 'Motion sensor',
    value:
      'Wave your hand in front of the frame to turn the light on and off. No button to find with gloves on, greasy hands or full hands.',
  },
  { label: 'Brightness', value: '800 lumens from dual LED modules, with 3 brightness levels' },
  { label: 'Runtime', value: 'Up to 14 hours on low, 5 hours on high' },
  { label: 'Charge time', value: '90 minutes to full over USB-C. A 10-minute top-up runs about an hour.' },
  { label: 'Weight', value: '1.4 oz (40 g), lighter than most safety glasses' },
  { label: 'Light', value: 'Dual LED modules built into the frame, aimed at your line of sight' },
  { label: 'Charging', value: 'USB-C, the same cable as your phone. Cable included.' },
  { label: 'Lenses', value: '3 interchangeable: Clear, Amber, Smoke. All in the box.' },
  { label: 'Lens changes', value: 'Tool-free. Pop one out, snap the next in.' },
  { label: 'Worn like', value: 'Standard work glasses. No head strap, no battery pack.' },
  { label: 'Under a hard hat', value: 'Yes. Wears flat against the temples, nothing on the crown.' },
  {
    label: 'Prescription-ready',
    value:
      'Yes, with the GritVue X1 RX Insert™ (sold separately). It sits behind the protective lens and your local optical shop fits your prescription lenses into it. Prescription lenses are not included.',
  },
  { label: 'Battery display', value: 'Digital readout on the frame shows exactly how much power is left.' },
  { label: 'Coverage', value: 'Lifetime free replacement + 30-day returns' },
  {
    label: 'In the box',
    value:
      'The complete system: X1 glasses, Clear + Amber + Smoke lenses, premium hard case, microfiber pouch, cleaning cloth, USB charging cable, GritVue anti-fog lens spray, quick start guide and authenticity card. Multi-packs add a free mystery gift.',
  },
  {
    label: 'Shipping',
    value: 'Ships USPS from our U.S. warehouses. Every order is insured and tracked.',
  },
]

export const discountOffer = {
  eyebrow: 'Before you go',
  headline: '$5 off your first X1',
  body: 'Still thinking about it? Take this with you. Works on every pack, including Buy 2, Get 1 Free.',
  code: '5OFF',
  cta: 'Use my code',
  note: 'Code 5OFF applies 5% off at checkout. One use per customer. Cannot be combined with other discounts.',
}

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'What comes with each GritVue X1?',
    a: 'Each X1 includes the illuminated frame plus Clear, Amber and Smoke interchangeable lenses.',
  },
  { q: 'Do I get all three lenses?', a: 'Yes. All three are included with every X1.' },
  {
    q: 'How do I turn the light on?',
    a: 'Wave your hand in front of the frame. The built-in motion sensor turns the light on and off, so you never have to find a button with gloves on, greasy hands or a tool in each hand.',
  },
  {
    q: 'How bright is it, and how long does it last?',
    a: '800 lumens from dual LED modules with 3 brightness levels, brighter than most work headlamps. Up to 14 hours of runtime on low and 5 hours on high, so a double shift will not leave you in the dark.',
  },
  {
    q: 'How long does it take to charge?',
    a: '90 minutes from empty to full over USB-C, using the same cable as your phone. A 10-minute top-up gets you about an hour of light.',
  },
  {
    q: 'How heavy is it?',
    a: '1.4 oz (40 g), lighter than most safety glasses. No head strap, no battery pack on your neck.',
  },
  { q: 'Is it rechargeable?', a: 'Yes. GritVue X1 is USB-C rechargeable.' },
  {
    q: 'Is this a headlamp?',
    a: 'No. X1 is worn like glasses, with illumination integrated into the frame.',
  },
  {
    q: 'Can I use it for work?',
    a: 'X1 is designed as illuminated work eyewear for hands-free visibility in a wide range of work and DIY environments.',
  },
  {
    q: 'Can I tell how much battery is left?',
    a: 'Yes. A digital battery display on the frame shows the charge you have left, so you are never guessing before a shift.',
  },
  {
    q: 'What is the lifetime free replacement?',
    a: 'If your X1 breaks, cracks, stops charging or a lens gets scratched, just email us with your order number and we take care of it. A replacement ships free. Every multi-pack (Buy 2 Get 1 Free, Buy 4 Get 2 Free and the Business / Crew Pack) carries our Lifetime Replacement Warranty on every unit, a $19.95 value included free, with no expiration and no registration. A single system is covered for 1 year.',
  },
  {
    q: 'How fast do you ship, and where from?',
    a: 'Every order ships from one of our U.S. warehouses. Orders placed before 2pm CT go out the same business day and typically arrive in 3 to 6 business days with tracking. Multi-packs ship free.',
  },
  {
    q: 'What if I just don\u2019t like it?',
    a: 'Send it back within 30 days for a full refund, and return shipping is on us. No forms to argue about. The lifetime replacement covers breakage; the 30-day return covers changing your mind.',
  },
  {
    q: 'Can I wear it under a hard hat?',
    a: 'Yes. The X1 wears flat against the temples with nothing on the crown of your head, so a hard hat sits normally.',
  },
  {
    q: 'Can I put my prescription in them?',
    a: 'Yes, with the GritVue X1 RX Insert™, sold separately. It is a removable prescription-ready insert that sits behind the X1 protective lens. Take it to your local optical shop and they make corrective lenses for it from your prescription. Prescription lenses are not included with the insert or the X1.',
  },
  {
    q: "What's the best deal?",
    a: 'One complete system is $49.95, 60% off the $124.95 regular price. Buy 2, Get 1 Free gives you 3 complete systems for $99.90, only $33.30 each. Buy 4, Get 2 Free gives you 6 for $179.95, just $29.99 each. Every unit is the full system.',
  },
]
